/**
 * CDN thumbnails for Pragmatic (PP) and Jili are keyed by numeric id when the API provides it.
 */
export function thumbnailUrlGameId(gameId, provider, game) {
  const useNumeric = false;
    // provider === 'Jili' ||
    // provider === 'PP' ||
    // provider === 'Pragmatic';
  if (!useNumeric || !game) return gameId;
  const n = game.gameIdNumeric ?? game.gameIDNumeric;
  if (n === undefined || n === null || n === '') return gameId;
  return n;
}
